import axios from "axios";
import Env from "@/logics/Envs.js";

export default async function (tid) {
    try {
        const params = { tid };
        const res = await axios.get(Env.apiPath + "deleteTransaction", { params });
        return res.data.error;
    } catch (err) {
        return err;
    }
}